import { useHistory } from 'react-router-dom';
import { useGlobalContext } from './globalContexte';

// Hook personnalisé pour la redirection et le rechargement de la page
const useRedirectAndReload = ({ url, typeLink = '' }) => {
  const history = useHistory();
  const global = useGlobalContext();
  return  () => {
    const location = {
      pathname: url,
      state: {
        typeLink
      }
    };
    history?.replace(location); // Utiliser replace() à la place de push()
    global?.setReload(global.reload + 1);
    //window.location.reload();
  };

};

export default useRedirectAndReload;

